// btw-front/src/pages/Home.jsx
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import Hero from "../components/sections/Hero";
import TrustBar from "../components/sections/TrustBar";
import Services from "../components/sections/Services";
import CertBear from "../components/sections/CertBear";
import UseCases from "../components/sections/UseCases";
import Process from "../components/sections/Process";
import About from "../components/sections/About";
import Results from "../components/sections/Results";
import ContactCTA from "../components/sections/ContactCTA";

export default function Home() {
  const { hash } = useLocation();

  // 다른 페이지에서 /#section 으로 진입 시 해당 섹션으로 자동 스크롤.
  // 섹션이 Fade 등으로 늦게 마운트되는 경우를 대비해 짧은 지연을 둠.
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace(/^#/, "");
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <div id="top" className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <TrustBar />
        <Services />
        <CertBear />
        <UseCases />
        <Process />
        <About />
        <Results />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}
